import { createNaveCustomerClient } from "../infrastructure/auth/nave-customer-client";

export const productionCustomerClient = createNaveCustomerClient();
